import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isIdentified } from '../../ui/builders/utils';
import { isInIframe } from '../../utils/utils';
import Header from './Header/Header';
import UnidentifiedHeader from '../../pages/ContestPage/unidentifiedHeader/UnidentifiedHeader';
import classes from './Layout.module.css';

const Layout = () => {

  const authState = useSelector((state) => state.auth);
  const { isAuth } = authState;
  const identified = isIdentified(authState);
  const [isPassVirtualSchoolLink, setIsPassVirtualSchoolLink] = useState(null);

  useEffect(() => {
    if (isAuth === null) {
      return;
    }
    const enableRedirect = window.config?.enableRedirect;
    const inIframe = isInIframe();
    if (enableRedirect && isAuth === true && !inIframe) {
      setIsPassVirtualSchoolLink(true);
      window.location.href = window.config?.virtualSchoolLink;
    } else {
      setIsPassVirtualSchoolLink(false);
    }
  }, [isAuth]);

  if (isPassVirtualSchoolLink === true || isPassVirtualSchoolLink === null) {
    return null;
  }

  return (
    <div className={classes.layout}>
      <Outlet />
    </div>
  );
};

export default Layout;
